"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatIDR = formatIDR;
exports.formatNumber = formatNumber;
exports.parseNumber = parseNumber;
exports.formatIDRShort = formatIDRShort;
exports.initials = initials;
/** Format an Indonesian Rupiah amount with thousand separators. */
function formatIDR(amount) {
    return 'Rp ' + Math.round(amount).toLocaleString('id-ID');
}
/** Format a number with id-ID thousand separators. Accepts strings/null and renders blank for non-finite. */
function formatNumber(value, opts) {
    if (value === null || value === undefined || value === '')
        return '';
    const n = typeof value === 'number' ? value : Number(value);
    if (!Number.isFinite(n))
        return '';
    const decimals = opts?.decimals;
    return n.toLocaleString('id-ID', decimals !== undefined ? { minimumFractionDigits: decimals, maximumFractionDigits: decimals } : undefined);
}
/** Parse a thousand-separated id-ID number string back to a JS number. Returns NaN when blank. */
function parseNumber(value) {
    if (!value)
        return NaN;
    const cleaned = value.replace(/\./g, '').replace(/,/g, '.');
    return Number(cleaned);
}
/** Short form: 1.840.000 → "Rp 1.8jt", 184.500.000 → "Rp 184jt" */
function formatIDRShort(amount) {
    const n = Math.round(amount);
    if (n >= 1_000_000_000)
        return 'Rp ' + (n / 1_000_000_000).toFixed(1) + 'M';
    if (n >= 1_000_000)
        return 'Rp ' + (n / 1_000_000).toFixed(1) + 'jt';
    if (n >= 1_000)
        return 'Rp ' + (n / 1_000).toFixed(0) + 'rb';
    return 'Rp ' + n.toLocaleString('id-ID');
}
/** Initials from a person's name, max 2 characters. */
function initials(name) {
    return name
        .split(' ')
        .filter(Boolean)
        .map(s => s[0])
        .slice(0, 2)
        .join('')
        .toUpperCase();
}
//# sourceMappingURL=format.js.map